import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const useRouteHistory = () => {
  const router = useRouter()

  useEffect(() => {
    const current = sessionStorage.getItem('currentPath')
    if (current && current !== router.asPath) {
      sessionStorage.setItem('prevPath', current)
    }
    sessionStorage.setItem('currentPath', router.asPath)
  }, [router.asPath])

  // console.log({ route: router.asPath })
  return {
    previous: sessionStorage.getItem('prevPath'),
    current: router.asPath,
  }
}
